import { Skeleton } from "shared/components/atoms/Skeleton";
import { TextSkeleton } from "shared/components/atoms/TextSkeleton";

interface Props {
  className?: string;
}

export const MenuListSkeleton = ({ className }: Props) => {
  return (
    <div className={className}>
      <div tw="flex">
        <div tw="w-1/2 mr-1">
          <Skeleton height={112} tw="w-full rounded" />
          <TextSkeleton lineCount={3} tw="mt-2" />
        </div>
        <div tw="w-1/2 ml-1">
          <Skeleton height={112} tw="w-full rounded" />
          <TextSkeleton lineCount={3} tw="mt-2" />
        </div>
      </div>
      <div tw="flex mt-4">
        <div tw="w-1/2 mr-1">
          <Skeleton height={112} tw="w-full rounded" />
          <TextSkeleton lineCount={3} tw="mt-2" />
        </div>
        <div tw="w-1/2 ml-1">
          <Skeleton height={112} tw="w-full rounded" />
          <TextSkeleton lineCount={3} tw="mt-2" />
        </div>
      </div>
    </div>
  );
};
